export function initialQueueDoctorId(user: { id: string; isDoctor?: boolean } | null | undefined): string {
  return user?.isDoctor ? user.id : '';
}
